import { Component, computed, input, output, signal } from '@angular/core';

export interface TRidWord {
  word: string;
  isSelectable: boolean;
  appearance: 'DEFAULT' | 'NEUTRAL' | 'INCORRECT' | 'CORRECT' | ((isSelected: boolean) => 'DEFAULT' | 'NEUTRAL' | 'INCORRECT' | 'CORRECT');
}

export function getWord(word: string | TRidWord): TRidWord {
  return typeof word === 'string' ? { word, isSelectable: false, appearance: 'DEFAULT' } : word;
}

@Component({
  selector: 'rid-word',
  imports: [],
  templateUrl: './rid-word.html',
  host: {
    class: 'block relative',
  },
})
export class RidWord {
  word = input.required<string>();
  rounded = input<'TOP' | 'BOTTOM' | 'ALL' | 'NONE'>('ALL');
  appearance = input<
    'DEFAULT' | 'NEUTRAL' | 'INCORRECT' | 'CORRECT' | ((isSelected: boolean) => 'DEFAULT' | 'NEUTRAL' | 'INCORRECT' | 'CORRECT')
  >('DEFAULT');

  // selections
  isSelectable = input<boolean>(false);
  isSelected = signal(false);

  tw = computed(() => {
    const _appearance = this.appearance();
    const appearance = typeof _appearance === 'string' ? _appearance : _appearance(this.isSelected());

    if (appearance === 'DEFAULT') {
      if (this.isSelectable()) {
        let tw = 'cursor-pointer hover:outline-blue-500 hover:text-blue-500 ';
        if (this.isSelected()) {
          tw += 'bg-blue-50 text-blue-500 outline-blue-500';
        } else {
          tw += 'bg-white outline-transparent';
        }
        return tw;
      } else return 'bg-white outline-transparent';
    } else {
      if (this.isSelected()) {
        return {
          NEUTRAL: 'bg-blue-100 text-blue-500 outline-blue-500',
          CORRECT: 'bg-green-100 text-green-500 outline-green-500',
          INCORRECT: 'bg-red-100 text-red-500 outline-red-500',
        }[appearance];
      } else
        return {
          NEUTRAL: 'bg-white text-blue-500 outline-blue-500',
          CORRECT: 'bg-white text-green-500 outline-green-500',
          INCORRECT: 'bg-white text-red-500 outline-red-500',
        }[appearance];
    }
  });
  twRounded = computed(() =>
    [
      this.rounded() === 'TOP' || this.rounded() === 'ALL' ? 'rounded-t-sm' : '',
      this.rounded() === 'BOTTOM' || this.rounded() === 'ALL' ? 'rounded-b-sm' : '',
    ].join(' '),
  );

  selectionChanged = output<boolean>();

  toggleSelection() {
    this.isSelected.set(!this.isSelected());
    this.selectionChanged.emit(this.isSelected());
  }
}
